import { Dispatch, SetStateAction } from 'react';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const UNSAVED_CHANGES_MODAL_TEXT = {
  bodyText: 'There are unsaved changes. Do you want to save them before you leave?',
  continueEditingButtonId: 'continue-editing-button',
  continueEditingButtonText: 'Continue editing',
  exitChangesButtonId: 'exit-changes-button',
  exitChangesButtonText: 'Leave without saving',
  modalId: 'unsaved-changes-modal',
  title: 'Unsaved changes',
};

const {
  bodyText,
  continueEditingButtonId,
  continueEditingButtonText,
  exitChangesButtonId,
  exitChangesButtonText,
  modalId,
  title,
} = UNSAVED_CHANGES_MODAL_TEXT;

type UnsavedChangesProps = {
  onClose: () => void;
  /** flag sent to Prompt to allow or disallow navigating away from the page */
  setShouldNavigate: Dispatch<SetStateAction<boolean>>;
};

export const UnsavedChangesModal = ({ onClose, setShouldNavigate }: UnsavedChangesProps) => {
  const handleContinueEditing = () => {
    setShouldNavigate(false);
    onClose();
  };

  const handleExitWithoutSaving = () => {
    setShouldNavigate(true);
    onClose();
  };

  return (
    <Modal
      id={modalId}
      isModalOpen
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      withPortal
    >
      <ModalHeader onClose={onClose} autoFocus={false}>
        {title}
      </ModalHeader>
      <ModalBody>{bodyText}</ModalBody>
      <ModalFooter hasCancel={false} onClose={onClose}>
        <Button
          data-test={exitChangesButtonId}
          onClick={handleExitWithoutSaving}
          size={BUTTON_SIZES.LARGE}
          type="button"
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          {exitChangesButtonText}
        </Button>
        <Button
          data-test={continueEditingButtonId}
          onClick={handleContinueEditing}
          size={BUTTON_SIZES.LARGE}
          type="button"
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          {continueEditingButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
